import { Dispatch, SetStateAction, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { UserContext } from 'contexts/user'

import ModalContainer from './ModalContainer'
import PrimaryButton from './primaryButton'

const CERRAR_SESSION = {
  CERRAR: 'Cerrar sesión',
  CONFIRMAR: 'Confirmar',
  MSJ: '¿Seguro que quiere cerrar sesión?'
}

const { CERRAR, CONFIRMAR, MSJ } = CERRAR_SESSION

interface LogoutModalProps {
  isOpen: boolean
  setIsOpen: Dispatch<SetStateAction<boolean>>
  closeMenu?: () => void
}

const LogoutModal = ({
  isOpen,
  setIsOpen,
  closeMenu = () => null
}: LogoutModalProps) => {
  const { logout } = useContext(UserContext)
  const navigate = useNavigate()

  return (
    <ModalContainer
      title={CERRAR}
      isShown={isOpen}
      setModalFunction={setIsOpen}
    >
      <p className='text-center'>{MSJ}</p>
      <div className='border-t border-solid border-gray-500 mb-6 mt-3' />
      <div className='flex mt-auto justify-between gap-12'>
        <PrimaryButton
          buttonText='Cancelar'
          primaryButtonFunction={() => setIsOpen(false)}
          outlined
        />
        <PrimaryButton
          buttonText={CONFIRMAR}
          primaryButtonFunction={() => {
            closeMenu()
            logout()
            navigate('/')
          }}
        />
      </div>
    </ModalContainer>
  )
}

export default LogoutModal
